export default __webpack_public_path__ + "static/media/987.15f00ad4.png";